import heic2any from "heic2any";

const SUPPORTED_IMAGE_TYPES = new Set([
  "image/jpeg",
  "image/jpg",
  "image/png",
  "image/heic",
  "image/heif",
]);

const SUPPORTED_IMAGE_EXTENSIONS = new Set([
  "jpg",
  "jpeg",
  "png",
  "heic",
  "heif",
]);

export const isSupportedCateringImage = (file) => {
  const extension = file.name.split(".").pop().toLowerCase();
  const hasSupportedType = SUPPORTED_IMAGE_TYPES.has(file.type.toLowerCase());
  const hasSupportedExtension = SUPPORTED_IMAGE_EXTENSIONS.has(extension);

  return (
    hasSupportedType ||
    ((!file.type || file.type === "application/octet-stream") &&
      hasSupportedExtension)
  );
};

export const isHeicImage = (file) => {
  const extension = file.name.split(".").pop().toLowerCase();
  return (
    ["image/heic", "image/heif"].includes(file.type.toLowerCase()) ||
    ["heic", "heif"].includes(extension)
  );
};

export const convertHeicToJpeg = async (file) => {
  const converted = await heic2any({
    blob: file,
    toType: "image/jpeg",
    quality: 0.9,
  });
  const jpegBlob = Array.isArray(converted) ? converted[0] : converted;
  const baseName = file.name.replace(/\.[^.]+$/, "");
  const jpegName = `${baseName || "catering-image"}.jpg`;

  return new File([jpegBlob], jpegName, {
    type: "image/jpeg",
    lastModified: file.lastModified,
  });
};
